export default __webpack_public_path__ + "static/StormwaterFees-7f9068480665178df1257a569d65c999.png";